import { Component, Input, OnInit } from '@angular/core';

import { LanguageService } from '../../../../core/services/language.service';
import { IsApplicationService } from '../../../../core/services/is-application.service';
import { NowService } from '../../../../core/services/now.service';

@Component({
  selector: 'app-public-footer',
  templateUrl: './public-footer.component.html',
  styleUrls: ['./public-footer.component.scss'],
})
export class PublicFooterComponent implements OnInit {
  @Input() isLanding;

  constructor(
    public languageService: LanguageService,
    public nowService: NowService,
    public isApplicationService: IsApplicationService
  ) {}

  ngOnInit(): void {}
}
